module.exports = __webpack_public_path__ + "static/InterFaceXBold-a443152c09ba4a256f4c4d228eb0292e.woff";